import { CentPrecisionMoneySchema } from './CentPrecisionMoneySchema';
import { DiscountSchema } from './DiscountSchema';
import { z } from 'zod';

export const DiscountedPriceSchema = z.object({
  value: CentPrecisionMoneySchema,
  discount: DiscountSchema,
});
